import React from 'react';
import { Check } from 'lucide-react';

const SuccessMessage = () => {
  return (
    <div className="flex flex-col items-center justify-center py-10 px-6 text-center">
      <Check size={40} className="text-success mb-4" />
      <p className="text-lg text-gray-900 m-0">Meeting successfully scheduled!</p>
    </div>
  );
};

export default SuccessMessage;